import * as React from 'react';
import { FlyoutContext } from '../utils/FlyoutContext';

export const useFlyout = () => React.useContext(FlyoutContext);
